import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const Product = ({ p, onChange }) => (
  <div className="bg-[#FAF7F2] border border-[#E2D9CC] p-6 space-y-3" data-testid={`reloc-product-${p.key}`}>
    <div className="grid sm:grid-cols-[1fr_140px] gap-3">
      <Input data-testid={`reloc-product-name-${p.key}`} value={p.name} onChange={(e) => onChange({ ...p, name: e.target.value })} className="rounded-none bg-white font-display text-lg" />
      <div className="flex items-center gap-2"><span className="text-sm text-[#8C827A]">A$</span>
        <Input data-testid={`reloc-product-price-${p.key}`} type="number" value={p.price_aud} onChange={(e) => onChange({ ...p, price_aud: Number(e.target.value) })} className="rounded-none bg-white" /></div>
    </div>
    <Input value={p.tagline} onChange={(e) => onChange({ ...p, tagline: e.target.value })} placeholder="Tagline" className="rounded-none bg-white" />
    <Textarea rows={4} value={p.description} onChange={(e) => onChange({ ...p, description: e.target.value })} className="rounded-none bg-white text-sm" />
    <Textarea rows={4} value={(p.bullets || []).join("\n")} onChange={(e) => onChange({ ...p, bullets: e.target.value.split("\n") })} className="rounded-none bg-white text-xs" placeholder="One bullet per line" />
  </div>
);

export const RelocListing = ({ g, onSaved }) => {
  const [items, setItems] = useState(g.listing.products || []);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const products = items.map((p) => ({ ...p, bullets: (p.bullets || []).map((b) => b.trim()).filter(Boolean) }));
      onSaved((await api.put(`/relocation/guides/${g.id}/listing`, { products })).data);
      toast.success("Listing saved — the shop picks it up on its next feed refresh");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-5" data-testid="reloc-listing">
      {items.map((p, i) => <Product key={p.key} p={p} onChange={(np) => setItems(items.map((x, j) => (j === i ? np : x)))} />)}
      <Button data-testid="reloc-listing-save" onClick={save} disabled={busy} className="rounded-none h-11 px-6">{busy ? "Saving…" : "Save listing"}</Button>
    </div>
  );
};
